<div class="position-relative w-100">
  <lui-card-doc class="card-type__card">
    <lui-card-doc-actions class="card-type__card-actions">
      <div class="hstack gap-_5">
        <button luiCab type="button" [disabled]="true">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      </div>
    </lui-card-doc-actions>
    <div class="d-flex">
      <lui-avatar [color]="'Castle View Corporate Holdings Ltd' | stringColor">
        CV
      </lui-avatar>
      <div class="d-flex flex-column text-start ms-2 pe-3">
        <h4>Castle View Corporate Holdings Ltd</h4>
        <span>(Parent company)</span>
      </div>
    </div>

    <div class="border-top mt-2 pt-2">
      <table class="card-type__table w-100">
        <tr>
          <td class="card-type__cell">Address:</td>
          <td class="card-type__cell bold">
            Compass House, Manor Royal, Crawley, West Sussex RH10 9PY
          </td>
        </tr>
      </table>
    </div>

    <div class="border-top mt-2 pt-2">
      <table class="card-type__table w-100">
        <tr>
          <td class="card-type__cell">Title of Insured:</td>
          <td class="card-type__cell bold">
            Castle View Corporate Holdings Ltd
          </td>
        </tr>
        <tr>
          <td class="card-type__cell">Business Description:</td>
          <td class="card-type__cell bold">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </td>
        </tr>
        <tr>
          <td class="card-type__cell">Websites/e-trading Services:</td>
          <td class="card-type__cell bold">
            <ul>
              <li class="card-type__link">
                <a href="#" target="_blank">www.castleviewholdings.com</a>
              </li>
              <li class="card-type__link">
                <a href="#" target="_blank">www.cvh.com </a>
              </li>
            </ul>
          </td>
        </tr>
      </table>
    </div>
  </lui-card-doc>

  <lui-card-doc class="card-type__card mt-1">
    <lui-card-doc-actions class="card-type__card-actions">
      <div class="hstack gap-_5">
        <button luiCab type="button" [disabled]="true">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      </div>
    </lui-card-doc-actions>
    <div class="d-flex">
      <lui-avatar
        [color]="'Castle View International Holdings Limited' | stringColor"
      >
        CV
      </lui-avatar>
      <div class="d-flex flex-column text-start ms-2 pe-3">
        <h4>Castle View International Holdings Limited</h4>
        <span>(Subsidiary)</span>
      </div>
    </div>

    <div class="border-top mt-2 pt-2">
      <table class="card-type__table w-100">
        <tr>
          <td class="card-type__cell">Address:</td>
          <td class="card-type__cell bold">
            Castle Complex, Manor Royal, Crawley, West Sussex RH10 9PY
          </td>
        </tr>
      </table>
    </div>
  </lui-card-doc>

  <lui-card-doc class="card-type__card mt-1">
    <lui-card-doc-actions class="card-type__card-actions">
      <div class="hstack gap-_5">
        <button luiCab type="button" [disabled]="true">
          <mat-icon svgIcon="edit"></mat-icon>
        </button>
      </div>
    </lui-card-doc-actions>
    <div class="d-flex">
      <lui-avatar [color]="'Castle View Ventures Limited' | stringColor">
        CV
      </lui-avatar>
      <div class="d-flex flex-column text-start ms-2 pe-3">
        <h4>Castle View Ventures Limited</h4>
        <span>(Subsidiary)</span>
      </div>
    </div>

    <div class="border-top mt-2 pt-2">
      <table class="card-type__table w-100">
        <tr>
          <td class="card-type__cell">Address:</td>
          <td class="card-type__cell bold">
            House on Hill, Manor Royal, Crawley, West Sussex RH10 9PY
          </td>
        </tr>
      </table>
    </div>
  </lui-card-doc>
</div>

<formly-form
  class="d-none"
  [fields]="fields"
  [options]="options"
  (modelChange)="onModelChange($event)"
></formly-form>
